import { ZUimages } from "assets";

export const aboutCardData = [
  {
    id: "chat",
    icon: ZUimages.zuChatDots,
    icon2: "",
    title: "Live Chat",
    description: "Get instant answers to your questions about our product."
  },
  {
    id: "tech",
    icon: ZUimages.zuTool,
    icon2: ZUimages.zuSettings,
    title: "Technical Support",
    description: "Email technical support for issues with our product."
  },
  {
    id: "billing",
    icon: ZUimages.zuCoins,
    icon2: "",
    title: "Billing & Payment",
    description:
      "Solve your billing & payment issues. Get answers about our pricing, payment channels, and subscriptions."
  }
];
